import { Save } from './../constants/actionType'

const initialState = {
    saveResponse:null,
    isSave: false,
    retrieveSmartCart:null,
    mtn:"",
    save_Invoked:false,
    creditDone:false,
    helpSave:false,
    saveDate:"",
    validateInput:false,
    emailError:false,
    mtnError:false,
    resumeMonErr:false,
    sendCartErr:false,
    resumeSavedMon:"",
    sendCartNum:"",
    resumeMonValueErr:false,
    resumeMonAttemptErr:false,
    invalidMTNErr:false,
    sendCartMTNErr:false,
    sendCartEmailErr:false,
    resumeAttempts: 0,
    saveModalInput:"",
    saveLqMtnInput:"",
    saveLqEmailInput:"",
    saveMHUserIdInput:"",
    saveMHPasswordInput: "",
    saveType:"MON", // currently this is hardcoded need to replace with save type from LQ response
    sendSmsOrEmail:"",
    sentSmsorEmail:false,
    issmartcartflow:false,
    resumeWinbackTN:null,
    resumeIsWinback:false,
    resumeRafStnID:"",
    sentSmsorEmailSuccess:false,
    isTNUpdatedForResumeSmartCart:false,
    isInternetAdded:false,
    isTvAdded:false,
    isVoiceAdded:false,
    cancelSmartCartClick:false,
    loadTNForSCResume: '',
    pdcSmartCartMON: '',
    scResumeSourceCaptured: false,
    backInvoked: false,
    smartSaveEmailInfo: {
        isValidMail: false,
        eMailId: "",
        eMailErr: ""
    }
}

function save(state = initialState, action) {
    switch (action.type) {
        case Save.saveModalInput:
            return Object.assign({}, state, {
                saveModalInput: action.value
            })
        case Save.saveLqEmailInput:
            return Object.assign({}, state, {
                saveLqEmailInput: action.value
            })
        case Save.saveLqMtnInput:
            return Object.assign({}, state, {
                saveLqMtnInput: action.value
            })
        case Save.saveMHUserIdInput:
            return Object.assign({}, state, {
                saveMHUserIdInput: action.value
            })
        case Save.saveMHPasswordInput:
            return Object.assign({}, state, {
                saveMHPasswordInput: action.value
            })
        case Save.processSaveCart:
            return Object.assign({}, state, {
                saveResponse: action.value
            })
        case Save.smartSave:
            return Object.assign({}, state, {
                isSave: true
            })
        case Save.retrieveSmartCart:
            return Object.assign({}, state, {
                retrieveSmartCart: action.value
            })
        case Save.saveInvoked:
            return Object.assign({}, state, {
                save_Invoked: action.value
            })
        case Save.backInvoked:
            return Object.assign({}, state, {
                backInvoked: action.value
            })
        case Save.helpSave:
            return Object.assign({}, state, {
                helpSave: !action.value
            })
        case Save.creditDone:
            return Object.assign({}, state, {
                creditDone: action.value
            })
        case Save.expiryDate:
            return Object.assign({}, state, {
                saveDate: action.value
            })
        case Save.validateInput:
            return Object.assign({}, state, {
                validateInput: action.value
            })
        case Save.emailError:
            return Object.assign({}, state, {
                emailError: action.value
            })
        case Save.mtnError:
            return Object.assign({}, state, {
                mtnError: action.value
            })
        case Save.resumeMonErr:
            return Object.assign({}, state, {
                resumeMonErr: action.value
            })
        case Save.sendCartErr:
            return Object.assign({}, state, {
                sendCartErr: action.value
            })
        case Save.resumeMonValueErr:
            return Object.assign({}, state, {
                resumeMonValueErr: action.value
            })
        case Save.resumeMonAttemptErr:
            return Object.assign({}, state, {
                resumeMonAttemptErr: action.value
            })
       case Save.invalidMTNErr:
            return Object.assign({}, state, {
                invalidMTNErr: action.value
            })
        case Save.resumeSavedMon:
            return Object.assign({}, state, {
                resumeSavedMon: action.value
            })
        case Save.sendCartNum:
            return Object.assign({}, state, {
                sendCartNum: action.value
            })
        case Save.updateResumeAttempts:
            return Object.assign({}, state, {
                resumeAttempts: action.value
            })
        case Save.sendCartMTNErr:
            return Object.assign({}, state, {
                sendCartMTNErr: action.value
            })
        case Save.sendCartEmailErr:
            return Object.assign({}, state, {
                sendCartEmailErr: action.value
            })
        case Save.sendSmsOrEmail:
            return Object.assign({}, state, {
                sendSmsOrEmail: action.value
            })
        case Save.sentSmsorEmail:
            return Object.assign({}, state, {
                sentSmsorEmail: action.value
            })
        case Save.issmartcartFlow:
            return Object.assign({}, state, {
                issmartcartflow: action.value
            })
        case "RESUME_WINBACKTN":
            return Object.assign({}, state, {
                resumeWinbackTN: action.value
            })
        case "RESUME_ISWINBACK":
            return Object.assign({}, state, {
                resumeIsWinback: action.value
            })
        case Save.sentSmsorEmailSuccess:
            return Object.assign({}, state, {
                sentSmsorEmailSuccess: action.value
            })
        case Save.isTNUpdatedForResumeSmartCart:
            return Object.assign({}, state, {
                isTNUpdatedForResumeSmartCart: action.value
            })
        case Save.loadTNForSCResume:
            return Object.assign({}, state, {
                loadTNForSCResume: action.value
            })
        case Save.pdcSmartCartMON:
            return Object.assign({}, state, {
                pdcSmartCartMON: action.value
            })            
        case Save.scResumeSourceCaptured:
            return Object.assign({}, state, {
                scResumeSourceCaptured: action.value
            })
        case Save.resumeInternetAdded:
            return Object.assign({}, state, {
                isInternetAdded: action.value
            })
        case Save.resumeTvAdded:
            return Object.assign({}, state, {
                isTvAdded: action.value
            })
        case Save.resumeVoiceAdded:
            return Object.assign({}, state, {
                isVoiceAdded: action.value
            })
        case Save.cancelSmartcart:
            return Object.assign({}, state, {
                saveResponse: null
            })
        case 'CANCEL_SMARTCARTCLICK':
            return Object.assign({}, state, {
                cancelSmartCartClick: action.value
            })
        case Save.onValidateSmartSaveEmail:
            let smartSaveInfo = Object.assign({}, state.smartSaveEmailInfo, {
                eMailId: action.value.eMailId,
                eMailErr: action.value.eMailErr,
                isValidMail: action.value.isValidMail
            })
            return Object.assign({}, state, {
                smartSaveEmailInfo: smartSaveInfo,
            })
        case "RESUME_RAFSTNID":
            return Object.assign({}, state, {
                resumeRafStnID: action.value
            })

        
        default:
            return state
    }

}

export default save